import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleComponent } from './article/article.component';
import { PipesModule } from '../pipes';  // Ensure this is properly imported
import { RouterModule } from '@angular/router';
import { TopUsersComponent } from './top-users/top-users.component';
import { UpcomingGeneralComponent } from './upcoming-general/upcoming-general.component';
import { LocksComponent } from './locks/locks.component';
import { PickSlipComponent } from './pick-slip/pick-slip.component';
import { FormsModule } from '@angular/forms';  // For handling ngModel binding
import { ChatBoxComponent } from '@app/views/pages/chat/chat-box/chat-box.component';
import { ChatCountComponent } from '@app/views/pages/chat/chat-count/chat-count.component';
import { RepliesComponent } from '@app/views/pages/chat/replies/replies.component';
import { ChatDataComponent } from './chat-data/chat-data.component';
import { AdvertisementComponent } from './advertisement/advertisement.component';
import { SubscriptionFeaturesSliderComponent } from './subscription-features-slider/subscription-features-slider.component';
import { CarouselModule } from 'ngx-owl-carousel-o';  // Ensure correct import for carousel component
import { AllGamesComponent } from './all-games/all-games.component';
import { ProfileComponent } from './profile/profile.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { AdditionalContentComponent } from './additional-content/additional-content.component';
import { ImgLazyDirective } from '../directives/img-lazy.directive';
import { PaginationComponent } from './pagination/pagination.component';
import { PopUpComponent } from '../../views/pages/pop-up/pop-up.component';  // Ensure the path is correct

@NgModule({
  declarations: [
    ArticleComponent,
    TopUsersComponent,
    UpcomingGeneralComponent,
    LocksComponent,
    PickSlipComponent,
    ChatBoxComponent,
    RepliesComponent,
    ChatCountComponent,
    ChatDataComponent,
    AdvertisementComponent,
    SubscriptionFeaturesSliderComponent,
    AllGamesComponent,
    ProfileComponent,
    AdditionalContentComponent,
    ImgLazyDirective,
    PaginationComponent,
    PopUpComponent  // Declare PopUpComponent here
  ],
  imports: [
    CommonModule,
    PipesModule,
    RouterModule,
    FormsModule,  // Import FormsModule for handling forms and ngModel
    CarouselModule,  // Import carousel module
    MatDatepickerModule,
    MatNativeDateModule
  ],
  exports: [
    ArticleComponent,
    TopUsersComponent,
    UpcomingGeneralComponent,
    LocksComponent,
    PickSlipComponent,
    ChatBoxComponent,
    RepliesComponent,
    ChatCountComponent,
    ChatDataComponent,
    AdvertisementComponent,
    SubscriptionFeaturesSliderComponent,
    AllGamesComponent,
    PipesModule,
    ProfileComponent,
    AdditionalContentComponent,
    ImgLazyDirective,
    PaginationComponent,
    PopUpComponent  // Export PopUpComponent so it can be used in other modules
  ],
})
export class SharedModule { }
